// ----------------------------------------------------------------------

export function emptyRows(page, rowsPerPage, arrayLength) {
  return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
}

function getNestedValue(row, path) {
  if (!path) return "";
  return path.split(".").reduce((obj, key) => obj?.[key], row);
}

function getObjectSortValue(value) {
  if (!value || typeof value !== "object") return value;
  if (Array.isArray(value)) return value.length
  if (value.firstName || value.lastName) return `${value.firstName || ""} ${value.lastName || ""}`.trim()
  if (value.venueName || value.name || value.title || value.businessName || value.label)
    return (
      value.venueName ||
      value.name ||
      value.title ||
      value.businessName ||
      value.label ||
      ""
    );
  if (value.username || value.email || value.phone || value.phoneNumber)
    return (
      value.username ||
      value.email ||
      value.phone ||
      value.phoneNumber ||
      ""
    );

  return Object.values(value).filter((item) =>
    typeof item === "string" ||
    typeof item === "number" ||
    typeof item === "boolean"
  ).join(" ");
}

function normalizeSortValue(value) {
  if (value === null || value === undefined) return "";
  const objectValue = getObjectSortValue(value);
  if (objectValue === null || objectValue === undefined) return "";
  if (objectValue instanceof Date) return objectValue.getTime();
  if (typeof objectValue === "string") return objectValue.trim().toLowerCase()
  if (typeof objectValue === "number") return objectValue;
  if (typeof objectValue === "boolean") return objectValue ? 1 : 0;
  return String(objectValue).trim().toLowerCase();
}

function getSortValue(row, orderBy, sortValueMap = {}) {
  if (sortValueMap?.[orderBy]) {
    return normalizeSortValue(sortValueMap[orderBy](row));
  }
  return normalizeSortValue(getNestedValue(row, orderBy));
}

function descendingComparator(a, b, orderBy, sortValueMap = {}) {
  const valueA = getSortValue(a, orderBy, sortValueMap);
  const valueB = getSortValue(b, orderBy, sortValueMap);
  if (valueB < valueA) return -1;
  if (valueB > valueA) return 1;
  return 0;
}

export function getComparator(order, orderBy, sortValueMap = {}) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy, sortValueMap)
    : (a, b) => -descendingComparator(a, b, orderBy, sortValueMap);
}